import React from 'react';
import {
  Box,
  Flex,
  Spinner,
  Text,
  Center,
  Button,
  Divider,
} from '@chakra-ui/react';
import StatusStep from './components/statusStep';

const OrderStepper = (props) => {
  const statusArray = props?.statusArray;

  return (
    <Box ml={2}>
      {statusArray?.map((step, index) => (
        <Flex
          mt={1}
          direction='column'
          gap={1}
          align='flex-start'
          key={index}>
          {index !== 0 && (
            <Flex
              ml={2}
              height={10}>
              <Divider
                borderColor='gray.300'
                borderWidth='1px'
                orientation='vertical'
              />
            </Flex>
          )}
          <StatusStep step={step} />
        </Flex>
      ))}
    </Box>
  );
};

export default OrderStepper;
